import { jsx as _jsx } from "react/jsx-runtime";
import { Banner, DataTable, Text } from '@dixa/lib-shared-habla';
import { companiesApi } from 'apis/companies';
import { normalizeUser } from 'app/views/layout/views/contacts/utils';
import { usePaginatedEndpoint } from 'utils/apis/pagination/usePaginatedEndpoint';
import { ContactsTableUser } from '../../../contactsTableUser/contactsTableUser';
export const CompanyRelatedUsers = ({ companyId, }) => {
    const { hasNextPage, hasPreviousPage, nextPage, previousPage, items: users, total, asyncStatus, } = usePaginatedEndpoint({
        endpoint: companiesApi.endpoints.readCompanyRelatedUsers,
        initialArg: { id: companyId, limit: 25, offset: 0 },
        totalSelector: ({ data: { users } }) => users.length,
        itemsSelector: ({ data: { users } }) => users,
    });
    const isLoading = asyncStatus === 'pending';
    const isSuccess = asyncStatus === 'fulfilled';
    if (isLoading && !total) {
        return _jsx(Text.Paragraph, { children: "Loading related users..." });
    }
    if (asyncStatus === 'rejected') {
        _jsx(Banner, { variant: "fail", icon: null, description: _jsx(Text.Paragraph, { children: "An error occurred while loading related users" }) });
    }
    if (!total) {
        return (_jsx(Banner, { variant: "info", icon: null, description: _jsx(Text.Paragraph, { children: "There are no related users for this company" }) }));
    }
    return (_jsx(DataTable, { data: users.map(normalizeUser), columns: [
            {
                label: 'User',
                selector: (user) => (_jsx(ContactsTableUser, { name: user.name, avatarUser: user })),
            },
            { label: 'Email', selector: ({ email }) => email },
            { label: 'Phone number', selector: ({ phone }) => phone },
            {
                label: 'Role',
                selector: ({ roleAttributes }) => roleAttributes === null || roleAttributes === void 0 ? void 0 : roleAttributes.prettyName,
            },
        ], paginationProps: {
            loading: isLoading,
            previousButtonDisabled: !hasPreviousPage || !isSuccess,
            nextButtonDisabled: !hasNextPage || !isSuccess,
            nextButtonClick: nextPage,
            previousButtonClick: previousPage,
        } }));
};
